/**
 * First-run onboarding tour — auto-triggered on first login.
 * Targets sidebar navigation landmarks present on every authenticated page.
 *
 * data-tour attributes expected in SideBarProvider / layout shell:
 *   sidebar-nav          The main navigation sidebar
 *   sidebar-dashboard    Dashboard nav link
 *   sidebar-queries      Manual Queries nav link
 *   sidebar-quotes       All Quotes nav link
 *   sidebar-notifications Notifications bell / link
 */

export const onboardingTour = {
  id: "onboarding",
  label: "Getting Started",
  steps: [
    {
      target: null, // centered welcome card — no spotlight needed
      title: "Welcome to FreightKit 👋",
      description:
        "This is your control center for managing freight quotes, queries, and conversations. Let us give you a quick 60-second tour so you can find your way around.",
      hint: "You can skip this tour at any time and restart it later from Settings.",
      placement: "center",
    },
    {
      target: "sidebar-nav",
      title: "Your Navigation Panel",
      description:
        "This panel on the left is how you move between different sections — Dashboard, Queries, Quotes, and more. Click any item to go there.",
      placement: "right",
    },
    {
      target: "sidebar-dashboard",
      title: "Dashboard",
      description:
        "Start here every day. The Dashboard shows you a live summary of your team's activity — active quotes, pending tasks, and recent completions.",
      placement: "right",
    },
    {
      target: "sidebar-queries",
      title: "Manual Queries",
      description:
        "Need to create a freight quote from scratch? Go to Manual Queries. Fill in the shipment details and FreightKit will help you build and track the query.",
      placement: "right",
    },
    {
      target: "sidebar-quotes",
      title: "All Quotes",
      description:
        "Every quote your team has worked on lives here. You can search, filter by status, and open any quote to see its full conversation history.",
      placement: "right",
    },
    {
      target: "sidebar-notifications",
      title: "Notifications",
      description:
        "The bell icon shows you updates that need your attention — new rate responses, shipper replies, or pending approvals.",
      placement: "right",
    },
    {
      target: null,
      title: "You're all set! 🎉",
      description:
        "That covers the basics. Each page also has its own short guide — just look for the tour icon or check Settings to replay any walkthrough.",
      placement: "center",
    },
  ],
};
